import {
  retrieveReportsUserProductivityReport,
  type RetrieveReportsUserProductivityReportInput,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveReportsUserProductivityReportQueryOptions = (
  filters: RetrieveReportsUserProductivityReportInput,
) => ({
  queryKey: [queryKeys.reports, "user-productivity-report", filters],
  queryFn: () => retrieveReportsUserProductivityReport(filters),
});
